import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/actions/new-document.actions';

const DocEditCell = ({ record, getPopupContainer }) => {
  const dispatch = useDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    // dispatch(
    //   actions.setVisibleDocumentDrawer({
    //     isVisible: true,
    //     document: record,
    //   })
    // );

    dispatch(
      actions.openEditDocument({
        formValues: record,
        documentId: record?.id,
      })
    );
  };

  return (
    <Tooltip
      title={'Редактировать документ'}
      mouseLeaveDelay={0}
      getPopupContainer={getPopupContainer}
      placement="topRight"
    >
      <Icon
        type="edit"
        style={{ cursor: 'pointer' }}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default DocEditCell;
